import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { globals } from '../globals';

const SettingsContext = createContext();

export function useSettings() {
  return useContext(SettingsContext);
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    disableSite: false,
    showSlider: false,
    enableEcommerce: true,
    enableAntitheft: true,
    enableComments: true,
    siteTitle: '',
    galleriesInHomepage: 12,
    singlePhotoPrice:3,
  });
  const [loading, setLoading] = useState(true); // Stato di caricamento

  useEffect(() => {
    async function fetchSettings() {
      try {
        const response = await axios.get(globals.homepageUrl + '/php/settings.php');
        if (response.data) {
          const newSettings = {
            disableSite: response.data.disable_site === '1',
            showSlider: response.data.show_slider === '1',
            enableEcommerce: response.data.enable_ecommerce === '1',
            enableAntitheft: response.data.enable_antitheft === '1',
            enableComments: response.data.enable_comments === '1',
            siteTitle: response.data.site_title || '',
            galleriesInHomepage: parseInt(response.data.galleries_in_homepage, 10) || 12,
            singlePhotoPrice: parseInt(response.data.single_photo_price, 10) || 3,
          };

          setSettings(newSettings); // Imposta le nuove impostazioni
          localStorage.setItem('settings', JSON.stringify(newSettings)); // Salva in localStorage
        }
      } catch (error) {
        console.error('Errore caricando le impostazioni del sito:', error);
      } finally {
        setLoading(false); // Impostiamo loading a false una volta che i dati sono stati caricati
      }
    }

    fetchSettings();
  }, []);

  useEffect(() => {
    localStorage.setItem('settings', JSON.stringify(settings));
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}
